<template>

    <div class="text-lg text-white font-light mb-12">
        Home theater vs. Media room comparison table:
    </div>

    <table class="w-full table-auto border-separate border-spacing-1.5 mb-12 -ml-1.5 table-margin">

        <thead>
            <tr>
                <th class="h-10 bg-neutral-800"></th>
                <th class="h-10 bg-neutral-800"></th>
                <th class="h-10 bg-neutral-800"></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="h-10 bg-neutral-700"></td>
                <td class="h-10 bg-neutral-700"></td>
                <td class="h-10 bg-neutral-700"></td>
            </tr>
            <tr>
                <td class="h-10 bg-neutral-700"></td>
                <td class="h-10 bg-neutral-700"></td>
                <td class="h-10 bg-neutral-700"></td>
            </tr>
            <tr>
                <td class="h-10 bg-neutral-700"></td>
                <td class="h-10 bg-neutral-700"></td>
                <td class="h-10 bg-neutral-700"></td>
            </tr>
            <tr>
                <td class="h-10 bg-neutral-700"></td>
                <td class="h-10 bg-neutral-700"></td>
                <td class="h-10 bg-neutral-700"></td>
            </tr>
            <tr>
                <td class="h-10 bg-neutral-700"></td>
                <td class="h-10 bg-neutral-700"></td>
                <td class="h-10 bg-neutral-700"></td>
            </tr>
        </tbody>

    </table>

</template>

<script setup>



</script>

<style>
.table-margin{
    width: calc(100% + 2 * (0.375rem))
}

</style>
